import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.checkliste-freigeben';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenChecklisteFreigebenEffects {

    ChecklisteFreigeben$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_CHECKLISTE_FREIGEBEN),
        mergeMap((x: ac.PostChecklisteFreigebenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postChecklisteFreigeben(x.checklisteFreigebenRequest).pipe(
                map((result: any) => {
                    return new ac.PostChecklisteFreigebenErfolgreichAction(result, x.checklisteFreigebenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostChecklisteFreigebenFehlerAction(error, x.checklisteFreigebenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ChecklistenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ChecklistenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.ChecklistenCommandService);
        }
        return this.service;
    }
}
